import { render, staticRenderFns } from "./PaymentMethodItemIcon.vue?vue&type=template&id=3f7a89fb&scoped=true&"
import script from "./PaymentMethodItemIcon.vue?vue&type=script&lang=ts&"
export * from "./PaymentMethodItemIcon.vue?vue&type=script&lang=ts&"
import style0 from "./PaymentMethodItemIcon.vue?vue&type=style&index=0&id=3f7a89fb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f7a89fb",
  null
  
)

export default component.exports